import announcement from './announcement.js';
import caseStudy from './caseStudy.js';
import newsletter from './newsletter.js';
import plainText from './plainText.js';
import branded from './branded.js';

export const TEMPLATES = { announcement, caseStudy, newsletter, plainText, branded };
// The two layouts that send come first in the picker.
export const TEMPLATE_LIST = [plainText, branded, announcement, caseStudy, newsletter];

// Two letter layouts send (owner, 2026-11-02): Plain text and Branded. The
// slot templates' picture, headline and story sections would be left out
// (functions/lib/eshot-templates.js holds the same list, and the server
// refuses the others too).
export const SENDABLE_TEMPLATE_IDS = ['plainText', 'branded'];

// The letter layouts (functions/lib/eshot-templates.js holds the same list).
// Kept apart from SENDABLE_TEMPLATE_IDS so a slot template that later learns
// to send does not become a letter.
export const LETTER_TEMPLATE_IDS = ['plainText', 'branded'];
export const SENDABLE_TEMPLATE_LIST = TEMPLATE_LIST.filter((t) => SENDABLE_TEMPLATE_IDS.includes(t.id));

// A letter layout: greeting, body and signature, written in the email itself.
export function isLetterTemplate(id) {
  return LETTER_TEMPLATE_IDS.includes(id);
}

export function getTemplate(id) {
  return TEMPLATES[id] || null;
}
